import React, { FC } from "react";
import { FieldSet, FormRow, FormRowFormats, Input } from "../../../../forms";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import TEXT from "../../../text-consts";

const HardwareOnly: FC = () => (
    <FieldSet name="hardwareOnly" legend={TEXT.PERSONAL_DETAILS.HARDWARE_ONLY.HEADING} data-di-mask>
        <Input type="text" name={VALIDATION_FIELD.FIRST_NAME} label={TEXT.PERSONAL_DETAILS.FIRSTNAME} />
        <Input type="text" name={VALIDATION_FIELD.LAST_NAME} label={TEXT.PERSONAL_DETAILS.LASTNAME} />
        <Input type="text" name={VALIDATION_FIELD.STREET} label={TEXT.PERSONAL_DETAILS.STREET} />
        <FormRow format={FormRowFormats.FORTY_SIXTY}>
            <Input type="text" name={VALIDATION_FIELD.POSTCODE} label={TEXT.PERSONAL_DETAILS.POSTCODE} />
            <Input type="text" name={VALIDATION_FIELD.CITY} label={TEXT.PERSONAL_DETAILS.CITY} />
        </FormRow>
        <FormRow format={FormRowFormats.FORTY_SIXTY}>
            <Input type="tel" name={VALIDATION_FIELD.PHONE} label={TEXT.COMMON.MOBILENUMBER} />
            <Input
                type="email"
                name={VALIDATION_FIELD.EMAIL}
                label={TEXT.PERSONAL_DETAILS.EMAIL}
                placeholder="ola@nordmann.no"
            />
        </FormRow>
    </FieldSet>
);

export default HardwareOnly;
